import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { Loader } from "@design-system/Loader/Loader";

interface ExportMenuItemProps {
    isDownloading: boolean;
    onClick: () => void;
    children: React.ReactNode;
}

/**
 * A menu row that starts a download and keeps the menu open, showing a
 * spinner in its leading slot while the file is being prepared.
 */
export const ExportMenuItem: React.FC<ExportMenuItemProps> = ({
    isDownloading,
    onClick,
    children,
}) => (
    <Menu.Item
        closeOnClick={false}
        onClick={onClick}
        leading={isDownloading ? <Loader inline /> : undefined}
    >
        {children}
    </Menu.Item>
);
